module.exports = __webpack_public_path__ + "img/logo-light.bc94851a.png";